import React, { memo, useEffect, useState, useCallback, useMemo } from "react";
import moment from "moment";
import { debounce } from "lodash";
import axios from "../../API/axios";
import { getUnreadNotificationCount } from "../../Services/apiService";
import { ShimmerThumbnail } from "react-shimmer-effects";
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import { post } from "../../config/imagesLink";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Link } from "react-router-dom";
import NotificationAction from "./NotificationAction";
import { ListRowSkeleton } from "@skeleton";
import WorkOutlineSharpIcon from '@mui/icons-material/WorkOutlineSharp';
import ChatBubbleOutlineSharpIcon from '@mui/icons-material/ChatBubbleOutlineSharp';
import FavoriteBorderSharpIcon from '@mui/icons-material/FavoriteBorderSharp';
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import useNotification from "antd/es/notification/useNotification";
import { useNotification as useNotificationContext } from "../Navigation/NotificationContext";        
import { useTranslation } from "react-i18next";
import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
import { Tooltip } from "@mui/material";
import { getLangKey, getStoredLangCode } from "../../utils/language";
import { translateNotificationContent } from "../../utils/notificationContent";

const Notification = memo(({notifiCount, setNotifiCount,}) => {
  const sessionId = useMemo(() => localStorage.getItem("sessionId"), []);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [noticationRead, setNoticationRead] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  // const { fetchNotificationCount } = useNotification();
  const { t} = useTranslation();
  const language = getStoredLangCode();
  const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
    // const [notifiCount, setNotifiCount] = useState("");
  
  // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------


 const NotificationCount = async ({ forceRefresh = false } = {}) => {
    try {
      const count = await getUnreadNotificationCount({ forceRefresh });
      if (count != null) {
        setNotifiCount(count);
      }
    } catch (error) {
      // if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
      //   setUnauthorisedModal(true)
      // }
    }
  };

  const NotificationList = async (page) => {
    const data = {
      "deviceType": "Web",
      "sessionId": sessionId,
      "pageNumber": page,
      "pageSize": 12,
      langKey: getLangKey(language),
    }
    try {
      setLoading(true);
      await axios
        .post(
          `/General/GetAllNotifications`, data
        )
        .then((resData) => {
          // console.log("resDataNew", resData.data);
          setIsLoading(false);
          setTotalPages(resData?.data?.responseData?.paging?.totalPages);

          const newnoti = resData?.data?.responseData.notificationsList;
          console.log("notificationList", newnoti);
          
          setNotificationList((prev) => {
            const postSet = new Set(prev?.map((post) => post?.ntfctnId));
            const uniquenewnoti = newnoti?.filter(
              (post) => !postSet?.has(post?.ntfctnId)
            );
            return [...prev, ...uniquenewnoti];
          });
          setLoading(false);
        });
    } catch (error) {
        console.log(error);

      if (error.response && error.response.status === 404) {
        setIsError(true);
        setIsLoading(false);

      } else {
        console.log(error);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (page <= totalPages) {
      NotificationList(page);
    }
  }, [page]);


  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handelInfiniteScroll);
    return () => window.removeEventListener("scroll", handelInfiniteScroll);
  }, []);



  const ReadNotification = async (id) => {
    console.log("Notification Id===>",id)

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: getLangKey(language),
    };
    try {
      await axios
        .post(`General/MarkNotificationAsRead?ID=${id}`, responseData)
        .then((res) => {
          // setShow(!show);
          // // toast.success(res.data.message);
          // setToastMessage(res.data.message);
          // setShowToast(true);
         NotificationCount({ forceRefresh: true })

        });
    } catch (e) {
      console.log(e.response);
      // if (e.response && e.response.status === 404) {
      //   setWarningToastMessage(e.response.data.message);
      //   setShowWarningToast(true);
      // } else {
      //   setErrorToastMessage(e.response.data.message);
      //   setShowErrorToast(true);
      // }
    }
  };

  const MarkAllNotificationsAsRead = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId,
      langKey: getLangKey(language),
    };
    try {
      await axios.post("General/MarkAllNotificationsAsRead", responseData);
      setNotificationList((prev) =>
        (prev || []).map((item) => ({ ...item, isView: true })),
      );
      NotificationCount({ forceRefresh: true });
    } catch (e) {
      console.log(e.response);
    }
  };

  const markAsRead = (id) => {
    setNotificationList((prevNotifications) =>
      prevNotifications.map((notification) =>
        notification.ntfctnId === id ? { ...notification, isView: false } : notification
      )
    );
  };

  //************************Delete Post start  ************************//

  const [showDropdown, setShowDropdown] = useState(false);
  const [deleteId, setDeleteId] = useState(null);


  const [show, setShow] = useState(false);
  const handleDeleteClose = () => {
    setShow(false);
  };

  const deleteNoti = async (event) => {
    event.preventDefault();
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios
        .post(`General/DeleteNotification?ID=${deleteId}`, responseData)
        .then((res) => {
          setShow(!show);
          // toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);

          setNotificationList((prev) => prev.filter((item) => item.ntfctnId !== deleteId));
          
          NotificationCount({ forceRefresh: true });
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [show]);

  //************************Delete Post End  ************************//


  return (
    <>
      <div className="notification-main-container">
        <div className="notification-header d-flex align-items-center justify-content-between">
          <div className="notificationMainText me-2">
            <h5>{t("Notifications.Notification")}</h5>
          </div>
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={MarkAllNotificationsAsRead}
            disabled={!notificationList?.length}
          >
            {t("Notifications.MarkAllRead", { defaultValue: "Mark all read" })}
          </button>
        </div>
        <div className="notification-messages">

          {isLoading ? (
            <ListRowSkeleton className="mt-3" count={5} rowHeight={80} showAvatar />
          )
            : isError ? (
              <div className="mt-5 text-center">
                <img src={post.errorSmall}  width={200} alt="404 Not Found" />
              </div>
            ) : (
              notificationList &&
              notificationList
                ?.filter((item) => !item.isDeleted)
                ?.map((item, index) => {

                    const now = moment.utc().local();
                    const itemTime = moment.utc(item?.time).local();
                    const diffSeconds = now.diff(itemTime, "seconds");
                    const diffMinutes = now.diff(itemTime, "minutes");
                    const diffHours = now.diff(itemTime, "hours");
                    const diffDays = now.diff(itemTime, "days");
                    const diffMonths = now.diff(itemTime, "months", true);
                    const diffYears = now.diff(itemTime, "years", true);

                    let result = "";

                    /* JUST NOW */
                    if (diffSeconds < 60) {
                      result = t("Notifications.Just Now");
                    }

                    /* MINUTES */
                    else if (diffMinutes < 60) {
                      result =
                        diffMinutes === 1
                          ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                          : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                    }

                    /* HOURS */
                    else if (diffHours < 24) {
                      result =
                        diffHours === 1
                          ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                          : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                    }

                    /* DAYS */
                    else if (diffDays < 30) {
                      result =
                        diffDays === 1
                          ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                          : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                    }

                    /* MONTHS */
                    else if (diffMonths < 12) {
                      const displayMonth =
                        diffMonths >= 0.75 && diffMonths < 1.25
                          ? 1
                          : Math.round(diffMonths * 2) / 2;

                      result =
                        displayMonth === 1
                          ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                          : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                    }

                    /* YEARS */
                    else {
                      const displayYear =
                        diffYears >= 0.75 && diffYears < 1.25
                          ? 1
                          : Math.round(diffYears * 2) / 2;

                      result =
                        displayYear === 1
                          ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                          : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                    }

                  
                  return (
                    <>

                      {item?.isView === false ? item?.type === 3 || item?.type === 12 || item?.type === 13 || item?.type === 14 || item?.type === 15 || item?.type === 16 ?
                        <Link to={`/User/${item?.fromUserUid}`} target="_blank" onClick={(e) => {
                          ReadNotification(item?.ntfctnId);
                          // readNotification or unreadNotification ka code kya 
                          setNotificationList((prev) =>
                            prev.map((notif) =>
                              notif.ntfctnId === item?.ntfctnId
                                ? { ...notif, isRead: true }
                                : notif
                            )
                          );
                        }}>
                          {/* <div className="custom-message-card unreadNotification d-flex justify-content-between align-items-center p-2"> */}
                          <div
                            className={`custom-message-card d-flex justify-content-between align-items-center p-2 
                                   ${item?.isRead ? "readNotification" : "unreadNotification"}`}
                          >
                            <Link to={`/User/${item?.fromUserUid}`} onClick={(e) => {
                              ReadNotification(item?.ntfctnId);
                            }}>
                              <div className="msgLeft d-flex">
                                <div className="ImgAvatar me-3">
                                  <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                </div>
                                <div className="messageCardContent">
                                  <div className="messageMainText"><h1>{item?.fromUserFname} <span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                  <div className="messageSubText">
                                    {/* <h1>{result}
                                          </h1> */}
                                              {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}                                  
                                    </div>
                                </div>
                              </div>
                            </Link>
                            <div className="msgRight d-flex align-items-center">
                              <Link to={`/User/${item?.fromUserUid}`} onClick={(e) => {
                                ReadNotification(item?.ntfctnId);
                              }}>
                                {item?.typeName === "JobPost" ? (
                                  <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                    <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                  </div>
                                ) : item?.typeName === "Message" ? (
                                  <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                    <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                  </div>
                                ) : item?.typeName === "Like" ? (
                                  <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                    <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                  </div>
                                ) : (
                                  ""
                                )}

                              </Link>
                              <Link onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setDeleteId(item?.ntfctnId);  // Save ID
                                setShow(true);                // Open modal
                                toggleDropdown();
                              }}>
                                <div className="d-flex align-items-center ">
                                  <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                    style={{ color: 'red !important' }} />
                                </div>
                              </Link>
                              <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                            </div>
                          </div> 
                          </Link> 
                          : item?.type === 1 || item?.type === 5 ?
                          <Link to={`/Post/${item?.refLinkId}`} target="_blank">
                            <div className="custom-message-card unreadNotification  d-flex justify-content-between align-items-center p-2">
                              <Link to={`/Post/${item?.refLinkId}`} target="_blank">
                                <div className="msgLeft d-flex">
                                  <Link to={`/Company/${item?.fromUserUid}`} target="_blank">
                                    <div className="ImgAvatar me-3">
                                      <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                    </div>
                                  </Link>
                                  <div className="messageCardContent">
                                    <div className="messageMainText"><h1><Link to={`/Company/${item?.fromUserUid}`} target="_blank">{item?.fromUserFname} </Link><span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                    <div className="messageSubText">
                                      {/* <h1>{result}</h1> */}
                                        {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                    </div>
                                  </div>
                                </div>
                              </Link>
                              <div className="msgRight d-flex align-items-center">
                                <Link to={`/Post/${item?.refLinkId}`} target="_blank">

                                  {item?.typeName === "JobPost" ? (
                                    <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                      <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                    </div>
                                  ) : item?.typeName === "Message" ? (
                                    <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                      <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                    </div>
                                  ) : item?.typeName === "Like" ? (
                                    <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                      <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </Link>
                                <Link onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setDeleteId(item?.ntfctnId);  // Save ID
                                  setShow(true);                // Open modal
                                  toggleDropdown();
                                }}>
                                  <div className="d-flex align-items-center ">
                                    <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                      style={{ color: 'red !important' }} />
                                  </div>
                                </Link>
                                <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                              </div>
                            </div>
                          </Link>
                          : item?.type === 2 ?
                            <Link onClick={(e) => {
                              ReadNotification(item?.ntfctnId);
                              // readNotification or unreadNotification ka code kya 
                              setNotificationList((prev) =>
                                prev.map((notif) =>
                                  notif.ntfctnId === item?.ntfctnId
                                    ? { ...notif, isRead: true }
                                    : notif
                                )
                              );
                            }} to={`/Message/${item?.fromUserUid}`} target="_blank">
                              {/* <div className="custom-message-card unreadNotification d-flex justify-content-between align-items-center p-2"> */}
                              <div
                                className={`custom-message-card d-flex justify-content-between align-items-center p-2 
                                   ${item?.isRead ? "readNotification" : "unreadNotification"}`}
                              >
                                <Link onClick={(e) => {
                                  ReadNotification(item?.ntfctnId);

                                }} to={`/Message/${item?.fromUserUid}`} target="_blank">
                                  <div className="msgLeft d-flex">
                                    <Link to={`/User/${item?.fromUserUid}`} target="_blank">
                                      <div className="ImgAvatar me-3">
                                        <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                      </div>
                                    </Link>
                                    <div className="messageCardContent">
                                      <div className="messageMainText"><h1><Link to={`/User/${item?.fromUserUid}`} target="_blank" className="me-2">{item?.fromUserFname}</Link><span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                      <div className="messageSubText">
                                        {/* <h1>{result}</h1> */}
                                          {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                                <div className="msgRight d-flex align-items-center">
                                  <Link onClick={(e) => {
                                    ReadNotification(item?.ntfctnId);
                                  }} to={`/Message/${item?.fromUserUid}`} target="_blank">
                                    {item?.typeName === "JobPost" ? (
                                      <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                        <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                      </div>
                                    ) : item?.typeName === "Message" ? (
                                      <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                        <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                      </div>
                                    ) : item?.typeName === "Like" ? (
                                      <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                        <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                      </div>
                                    ) : (
                                      ""
                                    )}

                                  </Link>
                                  <Link onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setDeleteId(item?.ntfctnId);  // Save ID
                                    setShow(true);                // Open modal
                                    toggleDropdown();
                                  }}>
                                    <div className="d-flex align-items-center ">
                                      <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                        style={{ color: 'red !important' }} />
                                    </div>
                                  </Link>
                                  <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                                </div>
                              </div>
                            </Link>
                            : item?.type === 4 || item?.type === 6 || item?.type === 7 || item?.type === 8 || item?.type === 9 || item?.type === 10 || item?.type === 11 || item?.type === 24 || item?.type === 18 ?
                              <Link onClick={() => {
                                ReadNotification(item?.ntfctnId)
                                // readNotification or unreadNotification ka code kya 
                                setNotificationList((prev) =>
                                  prev.map((notif) =>
                                    notif.ntfctnId === item?.ntfctnId
                                      ? { ...notif, isRead: true }
                                      : notif
                                  )
                                );
                              }} to={`/Post/${item?.refLinkId}`} target="_blank">
                                {/* <div className="custom-message-card unreadNotification d-flex justify-content-between align-items-center p-2"> */}
                                <div
                                  className={`custom-message-card d-flex justify-content-between align-items-center p-2
                                   ${item?.isRead ? "readNotification" : "unreadNotification"}`}
                                >
                                  <Link onClick={() => {
                                    ReadNotification(item?.ntfctnId)
                                    
                                  }} to={`/Post/${item?.refLinkId}`} target="_blank">
                                    <div className="msgLeft d-flex">
                                      <Link to={`/User/${item?.fromUserUid}`} target="_blank">
                                        <div className="ImgAvatar me-3">
                                          <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                        </div>
                                      </Link>
                                      <div className="messageCardContent">
                                        <div className="messageMainText"><h1><Link to={`/User/${item?.fromUserUid}`} target="_blank" className="me-2"> {item?.fromUserFname}</Link> <span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                        <div className="messageSubText">
                                          {/* <h1>{result}</h1> */}
                                            {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                          </div>
                                      </div>
                                    </div>
                                  </Link>
                                  <div className="msgRight d-flex align-items-center">
                                    <Link onClick={() => { ReadNotification(item?.ntfctnId) }} to={`/Post/${item?.refLinkId}`} target="_blank">

                                      {item?.typeName === "JobPost" ? (
                                        <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                          <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                        </div>
                                      ) : item?.typeName === "Message" ? (
                                        <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                          <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                        </div>
                                      ) : item?.typeName === "Like" ? (
                                        <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                          <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </Link>
                                    <Link onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setDeleteId(item?.ntfctnId);  // Save ID
                                      setShow(true);                // Open modal
                                      toggleDropdown();
                                    }}>
                                      <div className="d-flex align-items-center ">
                                        <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                          style={{ color: 'red !important' }} />
                                      </div>
                                    </Link>
                                    <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                                  </div>
                                </div>
                              </Link>
                              : item?.type === 17 || item?.type === 19 || item?.type === 20 || item?.type === 21 || item?.type === 22 || item?.type === 23 || item?.type === 25 || item?.type === 26 ?
                                <Link onClick={() => { ReadNotification(item?.ntfctnId) }} to={`/JobDetail/${item?.refLinkId}`} target="_blank">
                                  <div className="custom-message-card  unreadNotification d-flex justify-content-between align-items-center p-2">
                                    <Link onClick={() => { ReadNotification(item?.ntfctnId) }} to={`/JobDetail/${item?.refLinkId}`} target="_blank">
                                      <div className="msgLeft d-flex">
                                        <Link to={`/Company/${item?.fromUserUid}`} target="_blank">
                                          <div className="ImgAvatar me-3">
                                            <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                          </div>
                                        </Link>
                                        <div className="messageCardContent">
                                          <div className="messageMainText"><h1> <Link to={`/Company/${item?.fromUserUid}`} target="_blank">{item?.fromUserFname}</Link> <span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                          <div className="messageSubText">
                                            {/* <h1>{result}</h1> */}
                                              {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                            </div>
                                        </div>
                                      </div>
                                    </Link>
                                    <div className="msgRight d-flex align-items-center">
                                      <Link onClick={() => { ReadNotification(item?.ntfctnId) }} to={`/JobDetail/${item?.refLinkId}`} target="_blank">

                                        {item?.typeName === "JobPost" ? (
                                          <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                            <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                          </div>
                                        ) : item?.typeName === "Message" ? (
                                          <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                            <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                          </div>
                                        ) : item?.typeName === "Like" ? (
                                          <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                            <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Link >
                                      <Link onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setDeleteId(item?.ntfctnId);  // Save ID
                                        setShow(true);                // Open modal
                                        toggleDropdown();
                                      }}>
                                        <div className="d-flex align-items-center ">
                                          <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                            style={{ color: 'red !important' }} />
                                        </div>
                                      </Link>
                                      <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                                    </div>
                                  </div>
                                </Link>
                                :
                                <Link onClick={() => {
                                  ReadNotification(item?.ntfctnId)
                                  // readNotification or unreadNotification ka code kya 
                                  setNotificationList((prev) =>
                                    prev.map((notif) =>
                                      notif.ntfctnId === item?.ntfctnId
                                        ? { ...notif, isRead: true }
                                        : notif
                                    )
                                  );
                                }} to={`/User/${item?.fromUserUid}`} target="_blank">
                                  {/* <div className="custom-message-card unreadNotification d-flex justify-content-between align-items-center p-2"> */}
                                  <div
                                    className={`custom-message-card d-flex justify-content-between align-items-center p-2 
                                   ${item?.isRead ? "readNotification" : "unreadNotification"}`}
                                  >
                                    <Link onClick={() => {
                                      ReadNotification(item?.ntfctnId)
                                    }} to={`/User/${item?.fromUserUid}`} target="_blank">
                                      <div className="msgLeft d-flex">
                                        <div className="ImgAvatar me-3">
                                          <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                        </div>
                                        <div className="messageCardContent">
                                          <div className="messageMainText"><h1>{item?.fromUserFname} <span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                          <div className="messageSubText">
                                            {/* <h1>{result}</h1> */}
                                              {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                            </div>
                                        </div>
                                      </div>
                                    </Link>
                                    <div className="msgRight d-flex align-items-center">
                                      <Link onClick={() => { ReadNotification(item?.ntfctnId) }} to={`/User/${item?.fromUserUid}`} target="_blank">

                                        {item?.typeName === "JobPost" ? (
                                          <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                            <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                          </div>
                                        ) : item?.typeName === "Message" ? (
                                          <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                            <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                          </div>
                                        ) : item?.typeName === "Like" ? (
                                          <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                            <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Link>
                                      <Link onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setDeleteId(item?.ntfctnId);  // Save ID
                                        setShow(true);                // Open modal
                                        toggleDropdown();
                                      }}>
                                        <div className="d-flex align-items-center ">
                                          <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                            style={{ color: 'red !important' }} />
                                        </div>
                                      </Link>
                                      <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                                    </div>
                                  </div>
                                </Link>
                        : item?.type === 3 || item?.type === 12 || item?.type === 13 || item?.type === 14 || item?.type === 15 || item?.type === 16 ?
                          <Link to={`/User/${item?.fromUserUid}`} target="_blank">
                            <div className="custom-message-card  d-flex justify-content-between align-items-center p-2">
                              <Link to={`/User/${item?.fromUserUid}`} target="_blank">
                                <div className="msgLeft d-flex">
                                  <div className="ImgAvatar me-3">
                                    <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                  </div>
                                  <div className="messageCardContent">
                                    <div className="messageMainText"><h1>{item?.fromUserFname} <span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                    <div className="messageSubText">
                                      {/* <h1>{result}</h1> */}
                                        {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                      </div>
                                  </div>
                                </div>
                              </Link>
                              <div className="msgRight d-flex align-items-center">
                                <Link to={`/User/${item?.fromUserUid}`} target="_blank">

                                  {item?.typeName === "JobPost" ? (
                                    <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                      <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                    </div>
                                  ) : item?.typeName === "Message" ? (
                                    <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                      <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                    </div>
                                  ) : item?.typeName === "Like" ? (
                                    <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                      <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </Link>
                                <Link onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setDeleteId(item?.ntfctnId);  // Save ID
                                  setShow(true);                // Open modal
                                  toggleDropdown();
                                }}>
                                  <div className="d-flex align-items-center ">
                                    <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                      style={{ color: 'red !important' }} />
                                  </div>
                                </Link>
                                <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                              </div>
                            </div>
                          </Link>
                          : item?.type === 1 || item?.type === 5 ?
                            <Link to={`/Post/${item?.refLinkId}`} target="_blank">
                              <div className="custom-message-card  d-flex justify-content-between align-items-center p-2">
                                <Link to={`/Post/${item?.refLinkId}`} target="_blank">
                                  <div className="msgLeft d-flex">
                                    <Link to={`/Company/${item?.fromUserUid}`} target="_blank">
                                      <div className="ImgAvatar me-3">
                                        <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                      </div>
                                    </Link>
                                    <div className="messageCardContent">
                                      <div className="messageMainText"><h1><Link to={`/Company/${item?.fromUserUid}`} target="_blank">{item?.fromUserFname} </Link><span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                      <div className="messageSubText">
                                        {/* <h1>{result}</h1> */}
                                          {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                        </div>
                                    </div>
                                  </div>
                                </Link>
                                <div className="msgRight d-flex align-items-center">
                                  <Link to={`/Post/${item?.refLinkId}`} target="_blank">

                                    {item?.typeName === "JobPost" ? (
                                      <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                        <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                      </div>
                                    ) : item?.typeName === "Message" ? (
                                      <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                        <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                      </div>
                                    ) : item?.typeName === "Like" ? (
                                      <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                        <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </Link>
                                  <Link onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setDeleteId(item?.ntfctnId);  // Save ID
                                    setShow(true);                // Open modal
                                    toggleDropdown();
                                  }}>
                                    <div className="d-flex align-items-center ">
                                      <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                        style={{ color: 'red !important' }} />
                                    </div>
                                  </Link>
                                  <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                                </div>
                              </div>
                            </Link>
                            : item?.type === 2 ?
                              <Link to={`/Message/${item?.fromUserUid}`} target="_blank">
                                <div className="custom-message-card  d-flex justify-content-between align-items-center p-2">
                                  <Link to={`/Message/${item?.fromUserUid}`} target="_blank">
                                    <div className="msgLeft d-flex">
                                      <Link to={`/User/${item?.fromUserUid}`} target="_blank">
                                        <div className="ImgAvatar me-3">
                                          <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                        </div>
                                      </Link>
                                      <div className="messageCardContent">
                                        <div className="messageMainText"><h1><Link to={`/User/${item?.fromUserUid}`}
                                          target="_blank" className="me-2">{item?.fromUserFname}</Link> <span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                        <div className="messageSubText">
                                          {/* <h1>{result}</h1> */}
                                            {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                          </div>
                                      </div>
                                    </div>
                                  </Link>
                                  <div className="msgRight d-flex align-items-center">
                                    <Link to={`/Message/${item?.fromUserUid}`} target="_blank">

                                      {item?.typeName === "JobPost" ? (
                                        <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                          <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                        </div>
                                      ) : item?.typeName === "Message" ? (
                                        <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                          <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                        </div>
                                      ) : item?.typeName === "Like" ? (
                                        <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                          <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </Link>
                                    <Link onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setDeleteId(item?.ntfctnId);  // Save ID
                                      setShow(true);                // Open modal
                                      toggleDropdown();
                                    }}>
                                      <div className="d-flex align-items-center ">
                                        <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                          style={{ color: 'red !important' }} />
                                      </div>
                                    </Link>
                                    <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                                  </div>
                                </div>
                              </Link>
                              : item?.type === 4 || item?.type === 6 || item?.type === 7 || item?.type === 8 || item?.type === 9 || item?.type === 10 || item?.type === 11 || item?.type === 24 || item?.type === 18 ?
                                <Link to={`/Post/${item?.refLinkId}`} target="_blank">
                                  <div className="custom-message-card  d-flex justify-content-between align-items-center p-2">
                                    <Link to={`/Post/${item?.refLinkId}`} target="_blank">
                                      <div className="msgLeft d-flex">
                                        <Link to={`/User/${item?.fromUserUid}`} target="_blank">
                                          <div className="ImgAvatar me-3">
                                            <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                          </div>
                                        </Link>
                                        <div className="messageCardContent">
                                          <div className="messageMainText"><h1><Link to={`/User/${item?.fromUserUid}`} target="_blank" className="me-2"> {item?.fromUserFname}</Link> <span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                          <div className="messageSubText">
                                            {/* <h1>{result}</h1> */}
                                              {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                            </div>
                                        </div>
                                      </div>
                                    </Link>
                                    <div className="msgRight d-flex align-items-center">
                                      <Link to={`/Post/${item?.refLinkId}`} target="_blank">

                                        {item?.typeName === "JobPost" ? (
                                          <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                            <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                          </div>
                                        ) : item?.typeName === "Message" ? (
                                          <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                            <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                          </div>
                                        ) : item?.typeName === "Like" ? (
                                          <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                            <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Link>
                                      <Link onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setDeleteId(item?.ntfctnId);  // Save ID
                                        setShow(true);                // Open modal
                                        toggleDropdown();
                                      }}>
                                        <div className="d-flex align-items-center ">
                                          <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                            style={{ color: 'red !important' }} />
                                        </div>
                                      </Link>
                                      <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                                    </div>
                                  </div>
                                </Link>
                                : item?.type === 17 || item?.type === 19 || item?.type === 20 || item?.type === 21 || item?.type === 22 || item?.type === 23 || item?.type === 25 || item?.type === 26 ?
                                  <Link to={`/JobDetail/${item?.refLinkId}`} target="_blank">
                                    <div className="custom-message-card hjhdkah  d-flex justify-content-between align-items-center p-2">
                                      <Link to={`/JobDetail/${item?.refLinkId}`} target="_blank">
                                        <div className="msgLeft d-flex">
                                          <Link to={`/Company/${item?.fromUserUid}`} target="_blank">
                                            <div className="ImgAvatar me-3">
                                              <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                            </div>
                                          </Link>
                                          <div className="messageCardContent">
                                            <div className="messageMainText"><h1><Link to={`/Company/${item?.fromUserUid}`} target="_blank"> {item?.fromUserFname}</Link> <span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                            <div className="messageSubText">
                                              {/* <h1>{result}</h1> */}
                                                {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                              </div>
                                          </div>
                                        </div>
                                      </Link>
                                      <div className="msgRight d-flex align-items-center">
                                        <Link to={`/JobDetail/${item?.refLinkId}`} target="_blank">

                                          {item?.typeName === "JobPost" ? (
                                            <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                              <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                            </div>
                                          ) : item?.typeName === "Message" ? (
                                            <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                              <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                            </div>
                                          ) : item?.typeName === "Like" ? (
                                            <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                              <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </Link>
                                        <Link onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setDeleteId(item?.ntfctnId);  // Save ID
                                          setShow(true);                // Open modal
                                          toggleDropdown();
                                        }}>
                                          <div className="d-flex align-items-center ">
                                            <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                              style={{ color: 'red !important' }} />
                                          </div>
                                        </Link>
                                        <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                                      </div>
                                    </div>
                                  </Link>
                                  :
                                  <Link to={`/User/${item?.fromUserUid}`} target="_blank">
                                    <div className="custom-message-card  d-flex justify-content-between align-items-center p-2">
                                      <Link to={`/User/${item?.fromUserUid}`} target="_blank">
                                        <div className="msgLeft d-flex">
                                          <div className="ImgAvatar me-3">
                                            <img src={item?.fromProfilPic} alt="" style={{ borderRadius: '50px' }} />
                                          </div>
                                          <div className="messageCardContent">
                                            <div className="messageMainText"><h1>{item?.fromUserFname} <span className="textStyle">{translateNotificationContent(item?.content, t)}</span> </h1></div>
                                            <div className="messageSubText">
                                              {/* <h1>{result}</h1> */}
                                                {language === "ar" ? (
                                                 <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")} arrow>
                                                  <p className="f-10 label"> 
                                                    {moment
                                                    .utc(item?.time)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a")}
                                                 </p>
                                               </Tooltip>
                                             ) : (
                                                <Tooltip title={moment
                                                    .utc(item?.time)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip>
                                              
                                          )}   
                                              </div>
                                          </div>
                                        </div>
                                      </Link>
                                      <div className="msgRight d-flex align-items-center">
                                        <Link to={`/User/${item?.fromUserUid}`} target="_blank">

                                          {item?.typeName === "JobPost" ? (
                                            <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                                              <WorkOutlineSharpIcon className="material-symbols-outlined" />
                                            </div>
                                          ) : item?.typeName === "Message" ? (
                                            <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                                              <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                                            </div>
                                          ) : item?.typeName === "Like" ? (
                                            <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                                              <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </Link>
                                        <Link onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setDeleteId(item?.ntfctnId);  // Save ID
                                          setShow(true);                // Open modal
                                          toggleDropdown();
                                        }}>
                                          <div className="d-flex align-items-center ">
                                            <DeleteOutlineSharpIcon className=" noti-delet material-symbols-sharp me-2 pointer"

                                              style={{ color: 'red !important' }} />
                                          </div>
                                        </Link>
                                        <NotificationAction setNotificationList={setNotificationList} markAsRead={markAsRead} noticationRead={noticationRead} setNoticationRead={setNoticationRead} notifiID={item?.ntfctnId} NotificationList={NotificationList} page={page} item={item} />
                                      </div>
                                    </div>
                                  </Link>
                      }

                    </>
                  );
                })
            )}



        </div>
      </div>

      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={(e) => {
                    deleteNoti(e)
                    e.preventDefault(); // Prevents the default behavior (navigation)
                    e.stopPropagation()
                  }}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>


            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
});

export default Notification;
